import {UI} from "../../../../../../stem-core/src/ui/UIBase";

import {wrapInSpinner} from "../../../../../../core/ui/LoadingSpinner.jsx";
import {apiEditAddress} from "../../../../../../client/state/UserAddressStore";
import {AddressForm} from "../../../../../website/authenticated/pages/account/components/address/AddressForm";
import {Controller} from "../../../../flows/Controller.js";

// TODO @cleanup this seems to be mostly identical to AddAddressComponent
export class EditAddressComponent extends UI.Element {
    render() {
        return <AddressForm ref="form" address={Controller.address.selectedAddress}/>;
    }

    isValid() {
        return true;
    }

    @wrapInSpinner
    async getAddress() {
        if (!this.form.validateInputs()) {
            return null;
        }
        try {
            return await apiEditAddress({
                ...this.form.getValues(),
                userAddressId: Controller.address.selectedAddress.id
            });
        } catch (error) {
            if (error?.fields) {
                this.form.displayFieldErrors(error);
            }
            return null;
        }
    }
}
